export default __webpack_public_path__ + "static/media/walid.803ef9a5.png";